/**
 * Magic `?preview=` value that skips booking-reveal delay and view counting
 * while testing the public clip share page.
 */
export const CLIP_PREVIEW_BYPASS_VALUE = "123456789";

/** True when the current URL has the preview bypass query param. */
export function isClipPreviewBypassActive(): boolean {
  if (typeof window === "undefined") return false;
  return (
    new URLSearchParams(window.location.search).get("preview") ===
    CLIP_PREVIEW_BYPASS_VALUE
  );
}
